export default __webpack_public_path__ + "static/media/bottom-image-lg.07dfe90e.png";